export var OperatorDrawerNavs;
(function (OperatorDrawerNavs) {
    OperatorDrawerNavs["HOME"] = "HOME";
    OperatorDrawerNavs["REGISTER_TYPE"] = "REGISTER_TYPE";
    OperatorDrawerNavs["REGISTER_FORM"] = "REGISTER_FORM";
    OperatorDrawerNavs["EDIT_OPERATOR"] = "EDIT_OPERATOR";
})(OperatorDrawerNavs || (OperatorDrawerNavs = {}));
export var OperatorRoles;
(function (OperatorRoles) {
    OperatorRoles["MANAGING_PARTNER"] = "cst.managing_partner";
    OperatorRoles["OPERATOR"] = "cst.operator";
})(OperatorRoles || (OperatorRoles = {}));
export const SYS_ADMIN = 'sys.admin';
export var CustomOperatorPolicies;
(function (CustomOperatorPolicies) {
    CustomOperatorPolicies["TRANSACTION_LIMIT"] = "transaction-limit";
    CustomOperatorPolicies["INSTRUCTION_OPERATOR"] = "instruction-operator";
    CustomOperatorPolicies["ACCOUNT_MANAGER"] = "account-manager";
    CustomOperatorPolicies["ACCOUNT_PAYABLES_MANAGER"] = "account-payables-manager";
    CustomOperatorPolicies["BENEFITS_MANAGER"] = "benefits-manager";
    CustomOperatorPolicies["BILLING_MANAGER"] = "billing-manager";
    CustomOperatorPolicies["NFSE_MANAGER"] = "nfse-manager";
})(CustomOperatorPolicies || (CustomOperatorPolicies = {}));
export var CustomOperatorPoliciesIDs;
(function (CustomOperatorPoliciesIDs) {
    CustomOperatorPoliciesIDs["ACCOUNT_MANAGER"] = "account-manager";
    CustomOperatorPoliciesIDs["TRANSACTION_LIMIT"] = "transaction-limit";
    CustomOperatorPoliciesIDs["BENEFITS_MANAGER"] = "benefits-manager";
    CustomOperatorPoliciesIDs["BILLING_MANAGER"] = "billing-manager";
    CustomOperatorPoliciesIDs["NFSE_MANAGER"] = "nfse-manager";
})(CustomOperatorPoliciesIDs || (CustomOperatorPoliciesIDs = {}));
